import DarkModeHandler from './dark-mode';
import GrayScaleHandler from './gray-scale';
import FontSizeController from './font-size';

new DarkModeHandler();
new GrayScaleHandler();
new FontSizeController();